var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-red-600 pb-4"},[_c('p',[_vm._v(_vm._s(_vm.message))]),_c('ul',{staticClass:"list-inside list-disc"},_vm._l((_vm.errors),function(error,index){return _c('li',{key:index,staticClass:"text-sm"},[_vm._v("\n      "+_vm._s(error.field)+" "+_vm._s(error.message)+"\n    ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }